var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 3,
    transform: "matrix(1 0 0 -1 0 17)",
    fill: "#EE2A27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5267 12.3108C15.4548 12.4839 15.3172 12.6215 15.1442 12.6933C15.059 12.7296 14.9676 12.7489 14.875 12.75H11.3333C11.1455 12.75 10.9653 12.6754 10.8325 12.5425C10.6996 12.4097 10.625 12.2295 10.625 12.0417C10.625 11.8538 10.6996 11.6736 10.8325 11.5408C10.9653 11.408 11.1455 11.3333 11.3333 11.3333H13.1679L9.20833 7.37375L6.87791 9.71125C6.81206 9.77764 6.73372 9.83034 6.6474 9.8663C6.56108 9.90226 6.4685 9.92077 6.37499 9.92077C6.28148 9.92077 6.1889 9.90226 6.10258 9.8663C6.01627 9.83034 5.93792 9.77764 5.87208 9.71125L1.62208 5.46125C1.55568 5.3954 1.50299 5.31706 1.46703 5.23074C1.43107 5.14442 1.41255 5.05184 1.41255 4.95833C1.41255 4.86482 1.43107 4.77224 1.46703 4.68592C1.50299 4.59961 1.55568 4.52127 1.62208 4.45542C1.68792 4.38903 1.76627 4.33633 1.85258 4.30037C1.9389 4.26441 2.03148 4.24589 2.12499 4.24589C2.2185 4.24589 2.31108 4.26441 2.3974 4.30037C2.48372 4.33633 2.56206 4.38903 2.62791 4.45542L6.37499 8.20958L8.70541 5.87208C8.77126 5.80569 8.8496 5.753 8.93592 5.71703C9.02223 5.68107 9.11482 5.66256 9.20833 5.66256C9.30183 5.66256 9.39442 5.68107 9.48073 5.71703C9.56705 5.753 9.64539 5.80569 9.71124 5.87208L14.1667 10.3346V8.5C14.1667 8.31214 14.2413 8.13197 14.3741 7.99913C14.507 7.86629 14.6871 7.79167 14.875 7.79167C15.0629 7.79167 15.243 7.86629 15.3759 7.99913C15.5087 8.13197 15.5833 8.31214 15.5833 8.5V12.0417C15.5822 12.1342 15.563 12.2257 15.5267 12.3108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/decrease.09e23a454ef5d551e42a2ef1f16897e0.svg";
export { ForwardRef as ReactComponent };